// extracted by mini-css-extract-plugin
export default {"img":"Success_img__1acfU"};